"use client";

import styled from "styled-components";

export const TotalPayment = styled.div`
  padding: var(--Spacing-2, 0.2rem) var(--Spacing-6, 0.6rem);
  font-weight: 700;
`;
